<template>
  <!-- eslint-disable -->
  <p
    class="display-textarea"
    v-html="sanitizedLink(content)" />
  <!-- eslint-enable -->
</template>

<script>
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'

/**
 * @description textareaで保存した情報を表示する際のコンポーネント
 */
export default {
  mixins: [sanitizedLinkMixin],
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.display-textarea {
  background-color: $grey15;
  padding: 8px;
  border-radius: 4px;
  min-height: 48px;

  white-space: pre-line;
  word-wrap: break-word;
}
</style>